import React from 'react'

const Logo = () => {
  return (
    <a href="#index.html" className='logo'>Abiodun</a>
  )
}

export default Logo